/* eslint-disable camelcase, no-undef */

// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.7.0-LKl0HtBlpKLwpmTQiIJc/mode=imports,min/optimized/keen-slider.js'
// eslint-disable-next-line import/no-unresolved
import LZString from 'https://cdn.skypack.dev/lz-string'
const { getElement, getElements, formatMoney } = window.BAO.Utils

const { useArrows } = window.BAO.Carousel.plugins

const VisualiserURLState = {
  encode (obj) {
    try {
      return LZString.compressToEncodedURIComponent(JSON.stringify(obj))
    } catch (e) {
      return null
    }
  },
  decode (str) {
    try {
      return JSON.parse(LZString.decompressFromEncodedURIComponent(str))
    } catch (e) {
      return null
    }
  },
  read () {
    const params = new URLSearchParams(window.location.search)
    const build = params.get('b')
    return build ? this.decode(build) : null
  },
  push (state) {
    const encoded = this.encode(state)
    if (!encoded) return
    const params = new URLSearchParams(window.location.search)
    params.set('b', encoded)
    window.history.replaceState(
      {},
      '',
      `${window.location.pathname}?${params.toString()}${window.location.hash}`,
    )
  },
}

class bespokeVisualiser extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['addToCart', 'canvas', 'step']
  }

  connectedCallback () {
    super.connectedCallback()

    this.selectors = {
      charm: '[data-visualiser-charm]',
      quantity: '[data-visualiser-quantity]',
      infoShow: '[data-visualiser-info-show]',
      charmFilter: '[data-visualiser-charm-filter]',
      charmCollectionTrigger: '[data-visualiser-collection]',
      charmCollection: '[data-visualiser-charm-collection]',
    }

    this.visualiser = {
      product: {
        base_product_id: this.els.addToCart.element.dataset.baseProductId,
      },
      charms: [],
    }

    this.baseVariantId = this.els.addToCart.element.dataset.baseProduct
    this.baseVariantName = this.els.addToCart.element.dataset.variantName
    this.baseVariantPrice = parseInt(
      this.els.addToCart.element.dataset.variantPrice,
    )

    this.bvCanvas = new BVCanvas()

    this.urlParams = new URLSearchParams(window.location.search)
    this._buildState = VisualiserURLState.read()
    this._prefilling = !!this._buildState

    const defaultType =
      this._buildState?.pt || this.urlParams.get('productType')

    let defaultStage = 'type'
    if (defaultType) {
      defaultStage = 'style'
    }

    this.canvas = this.els.canvas.element

    this.currentStep = this._buildState?.st
      ? this._buildState.st
      : defaultType
        ? this.els.step.elements.length
        : this._buildState
          ? 2
          : 1
    this.currentStage = defaultStage
    this.activeStage = null

    this.productType = null
    this.productStyle = null
    this.productLength = null

    this.charmFilter = document.querySelectorAll(
      this.selectors.charmFilter,
    )[0].dataset.material

    this.charmMax = 0
    this.typeCharmMax = 0

    this.summary = true
    this.designSlideOut = true
    this.leadTimesDrawer = true
    this.leadTimes = false

    this.clickProductType(defaultType)

    if (!defaultType) {
      this._buildState = null
      this._prefilling = false
    }
  }

  setupListeners () {
    super.setupListeners()

    this.handleClick = this.handleClick.bind(this)

    this.els.next_step?.elements.forEach(trigger => {
      this.listeners.add(trigger, 'click', () => {
        if (trigger.dataset.productType) {
          this.productType = trigger.dataset.productType
          this.collection = trigger.dataset.collection
          this.charmMax = parseInt(trigger.dataset.max)
          this.typeCharmMax = parseInt(trigger.dataset.max)
          this.charmScale = parseInt(trigger.dataset.charmScale)
          this.charmPosition = parseInt(trigger.dataset.charmPosition)
          this.placeholderImage = trigger.dataset.placeholderImage
          this.sizeGuide = trigger.dataset.sizeGuide

          this.currentStep++
        } else {
          this.currentStep++
          VisualiserURLState.push(this._serializeBuildState())
        }
      })
    })

    this.els.stage_show?.elements.forEach(trigger => {
      this.listeners.add(trigger, 'click', () => {
        if (trigger.ariaDisabled !== 'true') {
          this.currentStage = trigger.dataset.stage
          this.activeStage = trigger.dataset.stage
        }
      })
    })

    this.els.close.elements.forEach(trigger => {
      this.listeners.add(trigger, 'click', () => {
        this.activeStage = null
      })
    })

    if (this.els.lucky) {
      this.els.lucky.elements.forEach(trigger => {
        this.listeners.add(trigger, 'click', () => {
          this.lucky = true
        })
      })
    }

    this.els.info_hide?.elements.forEach(trigger => {
      this.listeners.add(trigger, 'click', () => {
        this.infoSlide = ''
      })
    })

    this.els.product_type?.elements.forEach(trigger => {
      this.listeners.add(trigger, 'click', () => {
        if (!trigger.classList.contains('vis-Info_Square-selected')) {
          this.productType = trigger.dataset.productType
          this.collection = trigger.dataset.collection
          this.charmMax = parseInt(trigger.dataset.max)
          this.typeCharmMax = parseInt(trigger.dataset.max)
          this.charmScale = parseInt(trigger.dataset.charmScale)
          this.charmPosition = parseInt(trigger.dataset.charmPosition)
          this.placeholderImage = trigger.dataset.placeholderImage
          this.sizeGuide = trigger.dataset.sizeGuide
          this.activeStage = null
        }
      })
    })

    this.listeners.add(this, 'click', this.handleClick)

    this.els.summary_button?.elements.forEach(trigger => {
      this.listeners.add(trigger, 'click', () => {
        if (!trigger.disabled) {
          if (this.leadTimes !== true) {
            this.leadTimesDrawer = false
          }

          this.summary = false
        }
      })
    })

    this.els.summary_close?.elements.forEach(trigger => {
      this.listeners.add(trigger, 'click', () => {
        this.summary = true
      })
    })

    this.els.summary_edit?.elements.forEach(trigger => {
      this.listeners.add(trigger, 'click', () => {
        if (trigger.dataset.summaryEdit !== 'charms') {
          if (trigger.dataset.summaryEdit === 'design') {
            if (!trigger.disabled) {
              this.designSlideOut = false
            }
          } else {
            this.summary = true
            this.activeStage = trigger.dataset.summaryEdit
          }
        }
      })
    })

    this.els.design_close?.elements.forEach(trigger => {
      this.listeners.add(trigger, 'click', () => {
        this.designSlideOut = true
      })
    })

    this.els.leadTimes_close?.elements.forEach(trigger => {
      this.listeners.add(trigger, 'click', () => {
        this.leadTimesDrawer = true
        this.summary = false
      })
    })

    this.els.design_option?.elements.forEach(trigger => {
      this.listeners.add(trigger, 'click', () => {
        this.baseVariantId = trigger.dataset.variantId
        this.baseVariantName = trigger.dataset.variantName
        this.baseVariantPrice = parseInt(trigger.dataset.variantPrice)
      })
    })

    this.listeners.add(this.els.addToCart?.element, 'click', () => {
      BVSummary.addToCart(this.visualiser, this)
    })

    this.listeners.add(document, 'visualiser:remove', e => {
      this.updateCharm(parseInt(e.detail.index), 'remove')
    })

    this.listeners.add(document, 'visualiser:reorder', e => {
      this.updateCharm(e.detail.charms, 'reorder')
    })

    this.listeners.add(document, 'visualiser:updatePreview', e => {
      this.updateProduct('previewImage', e.detail.previewImage, false)
    })

    this.listeners.add(document, 'browser-back:click', e => {
      if (this.currentStep <= 1) return

      e.preventDefault()
      this.currentStep--
      VisualiserURLState.push(this._serializeBuildState())
    })

    this.els.copy_link?.elements.forEach(trigger => {
      this.listeners.add(trigger, 'click', () => {
        navigator.clipboard.writeText(window.location.href)
      })
    })

    this.renderListeners()
  }

  productEngravingUpdate (e) {
    const { productId, font, text } = e.detail

    const product_id = parseInt(productId)

    this.visualiser.charms.forEach(charm => {
      if (charm.id === product_id) {
        charm.engraving_font = font
        charm.engraving_text = text
      }
    })

    BVSummary.render(this.visualiser)
  }

  handleClick (e) {
    if (e.target.closest(this.selectors.quantity)) {
      const trigger = e.target.closest(this.selectors.quantity)

      const object = JSON.parse(
        getElement('.vis-Charms_Object', {
          context: trigger.closest(this.selectors.charm),
        }).innerText,
      )[0]

      if (trigger.closest(this.selectors.charm).dataset.engravingText) {
        object.engraving_text = trigger.closest(
          this.selectors.charm,
        ).dataset.engravingText
        object.engraving_font = trigger.closest(
          this.selectors.charm,
        ).dataset.engravingFont
      }

      this.updateCharm(object, trigger.dataset.qtyType)
    }

    if (e.target.closest(this.selectors.infoShow)) {
      e.preventDefault()
      e.stopPropagation()

      const trigger = e.target.closest(this.selectors.infoShow)
      this.infoSlide = trigger.dataset.handle
    }

    if (e.target.closest(this.selectors.charmFilter)) {
      const trigger = e.target.closest(this.selectors.charmFilter)
      this.charmFilter = trigger.dataset.material
    }

    if (e.target.closest(this.selectors.charmCollectionTrigger)) {
      e.preventDefault()
      e.stopPropagation()

      const trigger = e.target.closest(this.selectors.charmCollectionTrigger)
      this.charmCollection = trigger.dataset.handle
    }
  }

  renderCharmEdit () {
    this.els.summary_edit?.elements.forEach(trigger => {
      trigger.onclick = null
      trigger.onclick = () => this.summaryEditClick(trigger)
    })
  }

  summaryEditClick (trigger) {
    this.summary = true

    if (trigger.dataset.summaryEdit) {
      this.activeStage = trigger.dataset.summaryEdit
    }
  }

  renderListeners () {
    this.els.product_style?.elements.forEach(trigger => {
      this.listeners.add(trigger, 'click', e => {
        const infoEl = getElement('[data-visualiser-info-show]', {
          context: trigger,
        })
        if (infoEl.contains(e.target)) return

        this.productStyle = trigger.dataset.productStyle
        this.productId = trigger.dataset.productId
        this.productPrice = trigger.dataset.productPrice
        this.productImage = trigger.dataset.productImage
        this.charmSpacingItems = trigger.dataset.productSpacing

        this.charmMaxUpdate = this.typeCharmMax

        this.activeStage = null

        this.hideLength = trigger.dataset.productDefault
        if (trigger.dataset.productDefault === 'true') {
          getElements('.vis-Info_CapsuleList').forEach(variant => {
            if (variant.ariaHidden === 'false') {
              variant.firstElementChild.click()
            }
          })
        }
      })
    })

    this.els.product_length?.elements.forEach(trigger => {
      if (trigger.ariaDisabled === 'false') {
        this.listeners.add(trigger, 'click', () => {
          this.productLength = trigger.dataset.productLength
          this.variantId = trigger.dataset.variantId

          this.charmMaxUpdate =
            trigger.dataset.productMaxCharms ?? this.typeCharmMax

          this.activeStage = null
        })
      }
    })

    this.els.product_material?.elements.forEach(trigger => {
      this.listeners.add(trigger, 'click', () => {
        this.productMaterial = trigger.dataset.productMaterial
      })
    })
  }

  clickProductType (collection) {
    if (collection) {
      this.els.product_type?.elements.forEach(trigger => {
        if (trigger.dataset.collection === collection) {
          trigger.click()
        }
      })
    }
  }

  clickProductStyle (style) {
    if (style) {
      this.els.product_style?.elements.forEach(trigger => {
        if (trigger.dataset.productStyle === style) {
          trigger.click()
        }
      })
    }
  }

  async _prefillAfterStyle () {
    const build = this._buildState
    if (!build) return

    if (build.l) {
      this.els.product_length?.elements.forEach(trigger => {
        if (trigger.dataset.productLength === build.l) {
          trigger.click()
        }
      })
    }

    const productPreview = await this.bvCanvas.render(
      this.canvas,
      this.visualiser,
    )
    if (productPreview) this.visualiser.product.previewImage = productPreview

    if (build.sp != null) {
      getElements('[data-bespoke-visualiser-el="charm_spacing"]', {
        context: this,
      }).forEach(trigger => {
        if (parseFloat(trigger.dataset.spacing) === build.sp) {
          trigger.click()
        }
      })
    }

    if (build.c?.length > 0) {
      build.c.forEach(buildCharm => {
        const charmEl = getElement(`[data-charm-id="${buildCharm.id}"]`, {
          context: this,
        })
        if (!charmEl) return
        const charmsWrapper = charmEl.closest(this.selectors.charm)
        if (!charmsWrapper) return
        const object = JSON.parse(
          getElement('.vis-Charms_Object', { context: charmsWrapper }).innerText,
        )[0]
        if (buildCharm.et) {
          object.engraving_text = buildCharm.et
          object.engraving_font = buildCharm.ef
        }
        const qty = buildCharm.q || 1
        for (let i = 0; i < qty; i++) {
          this.updateCharm(object, 'plus')
        }
      })
    }

    if (build.dv) {
      this.els.design_option?.elements.forEach(trigger => {
        if (parseInt(trigger.dataset.variantId) === build.dv) {
          trigger.click()
        }
      })
    }

    this._checkBuildComplete()
  }

  async _checkBuildComplete () {
    if (!this._buildState) return

    this._buildState = null
    this._prefilling = false

    const preview = await this.bvCanvas.render(this.canvas, this.visualiser)
    if (preview) this.visualiser.product.previewImage = preview

    this._syncDOMAfterPrefill()
  }

  _syncCharmDOM () {
    const countById = {}
    const countByCategory = {}
    this.visualiser.charms.forEach(charm => {
      countById[charm.id] = (countById[charm.id] || 0) + 1
      countByCategory[charm.category] =
        (countByCategory[charm.category] || 0) + 1
    })

    document.querySelectorAll(this.selectors.charm).forEach(charm => {
      const id = parseInt(charm.dataset.charmId)
      charm.classList.toggle('vis-Charms_Product-selected', id in countById)
      getElement('.vis-Charms_ProductQtyItem-qty', {
        context: charm,
      }).innerHTML = countById[id] || 0
    })

    this.els.charm_count.elements.forEach(charm_count => {
      const cat = charm_count.dataset.category
      charm_count.ariaHidden = !(cat in countByCategory)
      charm_count.innerHTML = countByCategory[cat] || 0
    })

    this.els.charm_selected.elements.forEach(charm_selected => {
      const cat = charm_selected.dataset.category
      charm_selected.ariaHidden = !(cat in countByCategory)
      getElement('.vis-Charms_HeaderSelectedText', {
        context: charm_selected,
      }).innerHTML = countByCategory[cat] || 0
    })

    this.els.stage_value.elements.forEach(tile => {
      if (tile.dataset.stage === 'charms') {
        tile.innerHTML = this.visualiser.charms.length
        tile.classList.toggle(
          'vis-Visualiser_StepValue-active',
          this.visualiser.charms.length,
        )
      }
    })

    getElements('.vis-Visualiser_StepMax', { context: this }).forEach(
      maxValue => {
        maxValue.classList.toggle(
          'vis-Visualiser_StepMax-active',
          this.visualiser.charms.length,
        )
      },
    )

    this.els.bottomInfo.element.ariaHidden = this.visualiser.charms.length === 0

    Object.keys(countById).forEach(id => {
      const charm = this.visualiser.charms.find(c => c.id === parseInt(id))
      if (!charm) return
      getElements(
        `[data-charm-id="${id}"] .vis-Charms_ProductQtyItem-plus`,
      ).forEach(el => {
        el.classList.toggle(
          'vis-Charms_ProductQtyItem-disabled',
          countById[id] === charm.max,
        )
      })
    })
  }

  _syncDOMAfterPrefill () {
    this.els.stage_value.elements.forEach(stage => {
      const type = stage.dataset.stage
      if (type !== 'charms') {
        const value = this.visualiser.product[type]
        stage.innerHTML = value ?? 'None selected'
        if (type === 'spacing') stage.innerHTML = `${stage.innerText}cm`
        stage.classList.toggle('vis-Visualiser_StepValue-active', value)
      }
    })

    this.els.stage_show.elements.forEach(stage => {
      const s = stage.dataset.stage
      stage.dataset.completed = this.visualiser.product[s] != null
      if (this.visualiser.product.type && s === 'style') {
        stage.ariaDisabled = false
      }
      if (
        this.visualiser.product.style &&
        (s === 'length' || s === 'spacing')
      ) {
        stage.ariaDisabled = false
      }
      if (this.visualiser.product.length && s === 'charms') {
        stage.ariaDisabled = false
      }
    })

    this._syncCharmDOM()

    this.els.summary_button.elements.forEach(button => {
      const currentPrice =
        this.visualiser.product.price +
        this.visualiser.charms.reduce((acc, charm) => acc + charm.price, 0)
      const activeText = button.dataset.activeButtonText
      const inactiveText = button.dataset.inactiveButtonText

      if (this.visualiser.charms.length <= 0) {
        button.disabled = true
        if (currentPrice > 0) {
          button.innerText = `${inactiveText} - ${formatMoney(currentPrice)}`
        }
      } else {
        button.disabled = false
        if (currentPrice > 0) {
          button.innerText = `${formatMoney(currentPrice)} - ${activeText}`
        }
      }
    })

    BVSummary.render(this.visualiser)
    this.renderCharmEdit()
  }

  _serializeBuildState () {
    const charmMap = new Map()
    this.visualiser.charms.forEach(charm => {
      const key = charm.id
      if (charmMap.has(key)) {
        charmMap.get(key).q++
      } else {
        charmMap.set(key, {
          id: charm.id,
          vi: charm.variant_id,
          q: 1,
          et: charm.engraving_text || null,
          ef: charm.engraving_font || null,
        })
      }
    })

    return {
      v: 1,
      t: 'bespoke',
      st: this.currentStep,
      pt: this.visualiser.product.collection || null,
      ps: this.visualiser.product.style || null,
      l: this.visualiser.product.length || null,
      sp: this.visualiser.product.spacing || null,
      dv: this.visualiser.product.base_variant_id
        ? parseInt(this.visualiser.product.base_variant_id)
        : null,
      c: [...charmMap.values()],
    }
  }

  _pushBuildState () {
    if (this._prefilling) return
    if (!this.visualiser.product.collection) return
    VisualiserURLState.push(this._serializeBuildState())
  }

  /**
   * Show/hide the product information
   */
  get infoSlide () {
    return this._infoSlide
  }

  set infoSlide (productHandle) {
    if (productHandle) {
      fetch(`/products/${productHandle}?sections=bespoke-visualiser-info`)
        .then(response => response.json())
        .then(responseJSON => {
          getElement('.vis-CharmInfo_Target', {
            context: this.els.info.element,
          }).innerHTML = responseJSON['bespoke-visualiser-info']
          this.els.info.element.ariaHidden = productHandle.length <= 0

          this.initialiseInfoCarousel()
        })
        .catch(e => {
          console.error(e)
        })
    } else {
      this.els.info.element.ariaHidden = productHandle.length <= 0
    }

    this._infoSlide = productHandle
  }

  initialiseInfoCarousel () {
    if (this.els['info-slider']) {
      return new KeenSlider(
        this.els['info-slider'].element,
        {
          selector: this.els['info-slide'].elements,
          loop: true,
          slides: {
            origin: 'center',
            perView: 1,
          },
        },
        [
          carousel => {
            carousel.on('animationStarted', () => {
              const nextActiveIndex = carousel.track.absToRel(
                carousel.animator.targetIdx || 0,
              )

              carousel.slides.forEach((slide, index) => {
                slide.setAttribute('aria-current', index === nextActiveIndex)
              })

              this.activeIndex = nextActiveIndex
            })
          },
          useArrows({
            next: this.els['info-next'].element,
            previous: this.els['info-previous'].element,
          }),
        ],
      )
    }
  }

  initialiseDesignCarousel () {
    if (this.els['design-slider']) {
      return new KeenSlider(
        this.els['design-slider'].element,
        {
          selector: this.els['design-slide'].elements,
          loop: true,
          slides: {
            origin: 'center',
            perView: 1,
          },
        },
        [
          carousel => {
            carousel.on('animationStarted', () => {
              const nextActiveIndex = carousel.track.absToRel(
                carousel.animator.targetIdx || 0,
              )

              carousel.slides.forEach((slide, index) => {
                slide.setAttribute('aria-current', index === nextActiveIndex)
              })

              this.activeIndex = nextActiveIndex
            })
          },
          useArrows({
            next: this.els['design-next'].element,
            previous: this.els['design-previous'].element,
          }),
        ],
      )
    }
  }

  /**
   * Change current step of the visualiser
   */
  get currentStep () {
    return this._currentStep
  }

  set currentStep (currentStep) {
    this.els.step.elements.forEach(step => {
      step.ariaHidden = parseInt(step.dataset.step) !== currentStep
    })

    this._currentStep = currentStep
  }

  /**
   * Change current stage of the visualiser between material/length/charm etc...
   */
  get currentStage () {
    return this._currentStage
  }

  set currentStage (currentStage) {
    this.els.stage.elements.forEach(stage => {
      stage.ariaHidden = stage.dataset.stage !== currentStage
    })

    this.els.stage_show.elements.forEach(stageShow => {
      stageShow.classList.toggle(
        'vis-Visualiser_Step-active',
        stageShow.dataset.stage === currentStage,
      )
    })

    this._currentStage = currentStage
  }

  /**
   * Change current stage of the visualiser between material/length/charm etc...
   */
  get activeStage () {
    return this._activeStage
  }

  set activeStage (activeStage) {
    this.els.stage.elements.forEach(stage => {
      stage.ariaCurrent = stage.dataset.stage === activeStage
    })

    if (activeStage === 'charms') {
      getElement('.vis-Visualiser_Steps').ariaHidden = true
    } else {
      getElement('.vis-Visualiser_Steps').ariaHidden = false
    }

    if (activeStage && activeStage !== 'charms' && activeStage !== 'design') {
      getElement('.vis-Visualiser_InfoBackdrop', {
        context: this,
      }).ariaHidden = false
    } else {
      getElement('.vis-Visualiser_InfoBackdrop', {
        context: this,
      }).ariaHidden = true
    }

    this._activeStage = activeStage
  }

  /**
   * Change the base product ID
   */
  get baseVariantId () {
    return this._baseVariantId
  }

  set baseVariantId (id) {
    this.updateProduct('base_variant_id', id)

    this.els.design_option.elements.forEach(option => {
      option.classList.toggle(
        'vis-Design_Option-selected',
        option.dataset.variantId === id,
      )
    })

    this._baseVariantId = id
  }

  /**
   * Change the base product price
   */
  get baseVariantPrice () {
    return this._baseVariantPrice
  }

  set baseVariantPrice (price) {
    this.updateProduct('base_variant_price', price)

    this._baseVariantPrice = price
  }

  /**
   * Change the base product variant name
   */
  get baseVariantName () {
    return this._baseVariantName
  }

  set baseVariantName (name) {
    this.updateProduct('base_variant_name', name)

    this._baseVariantName = name
  }

  /**
   * Change the product type that is selected in the visualiser.
   */
  get productType () {
    return this._productType
  }

  set productType (productType) {
    this.els.product_type.elements.forEach(product_type => {
      product_type.classList.toggle(
        'vis-Info_Square-selected',
        product_type.dataset.productType === productType,
      )

      product_type.ariaSelected =
        product_type.dataset.productType === productType
    })

    if (this.visualiser.product.type) {
      this.resetSelected()
    }

    this.updateProduct('type', productType, false, 'style')

    this._productType = productType
  }

  /**
   * Change the product type that is selected in the visualiser.
   */
  get placeholderImage () {
    return this._placeholderImage
  }

  set placeholderImage (image) {
    this._placeholderImage = image

    this.els.placeholder.element.style.backgroundImage = `url("${image}")`
  }

  /**
   * Change the size guide per product type.
   */
  get sizeGuide () {
    return this._sizeGuide
  }

  set sizeGuide (handle) {
    this._sizeGuide = handle
    fetch(`/pages/${handle}?sections=bespoke-visualiser-size-guide`)
      .then(response => response.json())
      .then(responseJSON => {
        getElement('.vis-Info_SizeGuide', { context: this }).innerHTML =
          responseJSON['bespoke-visualiser-size-guide']
      })
      .catch(e => {
        console.error(e)
      })
  }

  /**
   * Change the product style
   */
  get productStyle () {
    return this._productStyle
  }

  set productStyle (productStyle) {
    this.els.product_style?.elements.forEach(product_style => {
      product_style.classList.toggle(
        'vis-Info_Square-selected',
        product_style.dataset.productStyle === productStyle,
      )

      product_style.ariaSelected =
        product_style.dataset.productStyle === productStyle
    })

    this.updateProduct('style', productStyle, false, 'length')

    this._productStyle = productStyle
  }

  /**
   * Change the product ID
   */
  get productId () {
    return this._productId
  }

  set productId (id) {
    getElements('[data-selected-product-id]', { context: this }).forEach(
      element => {
        element.ariaHidden = element.dataset.selectedProductId !== id
      },
    )

    this.updateProduct('id', parseInt(id))

    this._productId = id
  }

  /**
   * Change the product Price
   */
  get productPrice () {
    return this._productPrice
  }

  set productPrice (price) {
    this.updateProduct('price', parseInt(price))

    this._productPrice = price
  }

  /**
   * Change the product image
   */
  get productImage () {
    return this._productImage
  }

  set productImage (image) {
    this._productImage = image

    this.updateProduct('image', image, true)
    this.placeholderImage = ''
  }

  /**
   * Change the product image
   */
  get charmSpacingItems () {
    return this._charmSpacingItems
  }

  set charmSpacingItems (items) {
    const spacingItems =
      items === ''
        ? this.els.charm_spacings_group.element.dataset.default
        : items
    const spacingItemSplit = spacingItems.split(',')

    this.els.charm_spacings_group?.elements.forEach(trigger => {
      let charmSpacingHTML = ''

      spacingItemSplit.forEach(item => {
        if (trigger.dataset.type === 'capsule') {
          charmSpacingHTML += `<button class="vis-Info_Capsule" data-bespoke-visualiser-el="charm_spacing" data-max-charms="${this.typeCharmMax}" data-spacing="${item}">
            <p class="vis-Info_CapsuleTitle fz-14_171">${item}cm</p>

            <div class="vis-Info_CapsuleIcon">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="10" r="9.5" stroke="#2B2F2E"/>
                <path d="M5 10L8.5 13.5L15 7" stroke="#2B2F2E"/>
              </svg>
            </div>
          </button>`
        } else {
          charmSpacingHTML += `<button class="vis-Charms_SpacingItem fz-12_20" data-bespoke-visualiser-el="charm_spacing" data-max-charms="${this.typeCharmMax}" data-spacing="${item}">${item}cm</button>`
        }
      })

      trigger.innerHTML = charmSpacingHTML
    })

    this.charmSpacing = parseFloat(
      spacingItemSplit[spacingItemSplit.length - 1],
    )

    this.els.charm_spacing?.elements.forEach(trigger => {
      this.listeners.add(trigger, 'click', () => {
        this.charmMax = parseInt(trigger.dataset.maxCharms)
        this.charmSpacing = parseFloat(trigger.dataset.spacing)

        this.activeStage = null
      })
    })

    this._charmSpacingItems = spacingItems
  }

  /**
   * Change the product length
   */
  get productLength () {
    return this._productLength
  }

  set productLength (productLength) {
    this.els.product_length?.elements.forEach(product_length => {
      product_length.classList.toggle(
        'vis-Info_Capsule-selected',
        product_length.dataset.productLength === productLength,
      )

      product_length.ariaSelected =
        product_length.dataset.productLength === productLength
    })

    this.updateProduct('length', productLength, false, 'charms')

    this._productLength = productLength
  }

  /**
   * Change the product length
   */
  get variantId () {
    return this._variantId
  }

  set variantId (variantId) {
    this.updateProduct('variant_id', parseInt(variantId))

    this._variantId = variantId
  }

  /**
   * Change the product length
   */
  get variantName () {
    return this._variantName
  }

  set variantName (variantName) {
    this.updateProduct('variant_name', variantName)

    this._variantName = variantName
  }

  /**
   * Change product material selected
   */
  get productMaterial () {
    return this._productMaterial
  }

  set productMaterial (productMaterial) {
    this.updateProduct('material', productMaterial)

    this.showCorrectMaterial(productMaterial)

    this._productMaterial = productMaterial
  }

  /**
   * Change product material selected
   */
  get collection () {
    return this._collection
  }

  set collection (collection) {
    if (collection) {
      this.updateProduct('collection', collection)

      fetch(
        `/collections/${collection}?sections=bespoke-visualiser-style,bespoke-visualiser-length`,
      )
        .then(response => response.json())
        .then(responseJSON => {
          this.els.stage?.elements.forEach(stage => {
            const sectionId = `bespoke-visualiser-${stage.dataset.stage}`
            if (responseJSON[sectionId]) {
              getElement('.vis-Info_BodyTarget', { context: stage }).innerHTML =
                responseJSON[sectionId]
            }
          })

          this.showCorrectMaterial()
          this.renderListeners()

          const productStyle =
            this._buildState?.ps || this.urlParams.get('productStyle')
          if (productStyle) {
            this.clickProductStyle(productStyle)
          }

          if (this._buildState) {
            this._prefillAfterStyle()
          }

          this.productMaterial = this.els.product_material.element.dataset.productMaterial
        })
        .catch(e => {
          console.error(e)
        })
    }

    this._collection = collection
  }

  showCorrectMaterial (material) {
    const selectedMaterial = material ?? this.productMaterial

    getElements('[data-selected-product-material]', { context: this }).forEach(
      element => {
        element.ariaHidden =
          element.dataset.selectedProductMaterial !== selectedMaterial
      },
    )

    this.els.product_material?.elements.forEach(product_material => {
      product_material.classList.toggle(
        'vis-MaterialFilter_Icon-selected',
        product_material.dataset.productMaterial === selectedMaterial,
      )
    })

    getElements('.vis-MaterialFilter_FilterTextActive', {
      context: this,
    })?.forEach(activeText => {
      activeText.innerHTML = selectedMaterial
    })

    this.charmFilter = selectedMaterial
  }

  /**
   *
   * @param {*} type
   * @param {*} value
   * @param {*} render
   * @param {*} nextStage
   */
  async updateProduct (type, value, render, nextStage) {
    this.visualiser.product[type] = value
    if (this._prefilling) return

    this.els.stage_value.elements.forEach(stage => {
      if (stage.dataset.stage === type) {
        stage.innerHTML =
          type === 'spacing' && value != null
            ? `${value}cm`
            : value ?? 'None selected'

        stage.classList.toggle('vis-Visualiser_StepValue-active', value)
      }
    })

    this.els.stage_show.elements.forEach(stage => {
      if (stage.dataset.stage === type) {
        stage.dataset.completed = this.visualiser.product[type] !== null
      }

      if (nextStage) {
        if (
          stage.dataset.stage === nextStage &&
          this.visualiser.product[type]
        ) {
          stage.ariaDisabled = false
        }

        if (nextStage === 'length') {
          if (
            stage.dataset.stage === 'spacing' &&
            this.visualiser.product[type]
          ) {
            stage.ariaDisabled = false
          }
        }
      }
    })

    if (render) {
      this.visualiser.product.previewImage = await this.bvCanvas.render(
        this.canvas,
        this.visualiser,
      )
    }

    BVSummary.render(this.visualiser)
    this.renderCharmEdit()
    this._pushBuildState()
  }

  /**
   *
   */
  async resetSelected () {
    this.productStyle = null
    this.productLength = null
    this.productImage = ''
    this.variantId = null
    this.productPrice = null
    this.stage = null
    this.charmSpacing = null

    await this.updateCharm([], 'lucky')

    this.els.stage_show.elements.forEach(stage => {
      if (stage.dataset.stage !== 'type' && stage.dataset.stage !== 'style') {
        stage.ariaDisabled = true
      }
    })
  }

  /**
   * Hide variant tab
   */
  get hideLength () {
    return this._hideLength
  }

  set hideLength (hidden) {
    this.els.stage_show.elements.forEach(stage => {
      if (stage.dataset.stage === 'length') {
        stage.ariaDisabled = hidden
      }
    })

    this._hideLength = hidden
  }

  /**
   * Change the charm spacing
   */
  get charmSpacing () {
    return this._charmSpacing
  }

  set charmSpacing (charmSpacing) {
    this.els.charm_spacing?.elements.forEach(charm_spacing => {
      const className =
        charm_spacing.parentNode.dataset.type === 'capsule'
          ? 'vis-Info_Capsule-selected'
          : 'vis-Charms_SpacingItem-selected'
      charm_spacing.classList.toggle(
        className,
        parseFloat(charm_spacing.dataset.spacing) === charmSpacing,
      )
    })

    this.updateProduct('spacing', charmSpacing, true)

    this._charmSpacing = charmSpacing
  }

  /**
   * Change the charm max
   */
  get charmMax () {
    return this._charmMax
  }

  set charmMax (charmMax) {
    getElement('.vis-Visualiser_StepMaxValue', {
      context: this,
    }).innerHTML = charmMax
    this.els.charm_max.elements.forEach(element => {
      element.innerHTML = charmMax
    })

    this.updateProduct('max', charmMax)
    this.updateCharm(charmMax, 'max')

    this._charmMax = charmMax
  }

  /**
   * Change the charm scale
   */
  get charmScale () {
    return this._charmScale
  }

  set charmScale (charmScale) {
    this._charmScale = charmScale

    this.updateProduct('charmScale', charmScale)
  }

  /**
   * Change the charm position
   */
  get charmPosition () {
    return this._charmPosition
  }

  set charmPosition (charmPosition) {
    this._charmPosition = charmPosition

    this.updateProduct('charmPosition', charmPosition)
  }

  /**
   * Charm default filtering
   */
  get charmCollection () {
    return this._charmCollection
  }

  set charmCollection (charmCollection) {
    const charmCollections = getElements(this.selectors.charmCollection)
    const charmCollectionsMatch = charmCollections?.filter(
      collection => collection.dataset.category === charmCollection,
    )

    if (charmCollectionsMatch.length > 0) {
      charmCollections.forEach(collection => {
        collection.ariaHidden = collection.dataset.category !== charmCollection
      })

      const charmCollectionsTrigger = getElements(
        this.selectors.charmCollectionTrigger,
      )
      charmCollectionsTrigger.forEach(collection => {
        collection.ariaSelected = collection.dataset.handle === charmCollection
      })
    }

    this._charmCollection = charmCollection
  }

  /**
   * Charm default filtering
   */
  get charmFilter () {
    return this._charmFilter
  }

  set charmFilter (charmFilter) {
    const charmFilters = getElements(this.selectors.charmFilter)
    const charmFiltersMatch = charmFilters?.filter(
      filter => filter.dataset.material === charmFilter,
    )

    if (charmFiltersMatch.length > 0) {
      document.querySelectorAll(this.selectors.charmFilter).forEach(filter => {
        filter.classList.toggle(
          'vis-Charms_FilterIcon-selected',
          filter.dataset.material === charmFilter,
        )
      })

      getElements('.vis-Charms_FilterTextActive', { context: this })?.forEach(
        activeText => {
          activeText.innerHTML = charmFilter
        },
      )

      document.querySelectorAll(this.selectors.charm).forEach(charm => {
        charm.ariaHidden = charm.dataset.charmMaterial
          ? charm.dataset.charmMaterial !== charmFilter
          : false
      })

      // to sort accordion heights
      window.dispatchEvent(new Event('resize'))
    }

    this._charmFilter = charmFilter
  }

  /**
   *
   * @param {*} value
   */
  async updateCharm (value, action) {
    if (value) {
      const matchCurrent = this.visualiser.charms.filter(
        obj => obj.id === value.id,
      )

      if (
        (action === 'plus' &&
          this.visualiser.charms.length === this.visualiser.product.max) ||
        (action === 'plus' && matchCurrent.length >= value.max)
      ) {
        return
      }
    }

    switch (action) {
      case 'lucky':
        this.visualiser.charms = []
        for (let index = 0; index < value.length; index++) {
          const element = value[index]
          const trigger = getElement(`[data-charm-id="${element}"]`, {
            context: this,
          })

          if (!trigger) continue

          const object = JSON.parse(
            getElement('.vis-Charms_Object', {
              context: trigger.closest(this.selectors.charm),
            }).innerText,
          )[0]

          if (trigger.closest(this.selectors.charm).dataset.engravingText) {
            object.engraving_text = trigger.closest(
              this.selectors.charm,
            ).dataset.engravingText
            object.engraving_font = trigger.closest(
              this.selectors.charm,
            ).dataset.engravingFont
          }

          this.visualiser.charms.push(object)
        }

        break
      case 'remove':
        this.visualiser.charms = this.visualiser.charms.filter(
          (obj, index) => index !== value,
        )
        break
      case 'minus': {
        const removedIndex = this.visualiser.charms.findLastIndex(
          obj => obj.id === value.id,
        )
        this.visualiser.charms = this.visualiser.charms.filter(
          (obj, index) => index !== removedIndex,
        )
        break
      }
      case 'plus':
        if (this.visualiser.charms.length < this.visualiser.product.max) {
          this.visualiser.charms.push(value)
        }
        break
      case 'reorder':
        this.visualiser.charms = value
        break
      case 'max':
        this.visualiser.charms = this.visualiser.charms.filter(
          (obj, index) => index < value,
        )
        break
    }

    if (this._prefilling) return

    this._syncCharmDOM()

    if (action !== 'reorder') {
      this.visualiser.product.previewImage = await this.bvCanvas.render(
        this.canvas,
        this.visualiser,
      )
    }

    BVSummary.render(this.visualiser)
    this.renderCharmEdit()
    this._pushBuildState()

    // Disable/undisable the summary button
    this.els.summary_button.elements.forEach(button => {
      const currentPrice =
        this.visualiser.product.price +
        this.visualiser.charms.reduce((acc, charm) => acc + charm.price, 0)
      const activeText = button.dataset.activeButtonText
      const inactiveText = button.dataset.inactiveButtonText

      if (this.visualiser.charms.length <= 0) {
        button.disabled = true

        if (currentPrice > 0) {
          button.innerText = `${inactiveText} - ${formatMoney(currentPrice)}`
        }
      } else {
        button.disabled = false

        if (currentPrice > 0) {
          button.innerText = `${formatMoney(currentPrice)} - ${activeText}`
        }
      }
    })
  }

  /**
   * Summary open
   */
  get summary () {
    return this._summary
  }

  set summary (hidden) {
    this.els.summary.element.ariaHidden = hidden

    getElement('.vis-Visualiser_Column-selectors', {
      context: this,
    }).ariaHidden = !hidden

    this._summary = hidden
  }

  /**
   * Charm Max updating per variant
   */
  get charmMaxUpdate () {
    return this._charmMaxUpdate
  }

  set charmMaxUpdate (values) {
    const valuesArr = values.toString().split(',')

    this.els.charm_spacing?.elements.forEach((charm_spacing, i) => {
      if (valuesArr[i]) {
        charm_spacing.dataset.maxCharms =
          valuesArr[i] === '0' ? this.typeCharmMax : parseFloat(valuesArr[i])
      } else {
        charm_spacing.dataset.maxCharms =
          valuesArr[i] === '0'
            ? this.typeCharmMax
            : parseFloat(valuesArr[valuesArr.length - 1])
      }

      if (
        parseFloat(charm_spacing.dataset.spacing) ===
        this.visualiser.product.spacing
      ) {
        this.charmMax =
          valuesArr[i] === '0'
            ? this.typeCharmMax
            : parseFloat(charm_spacing.dataset.maxCharms)
      }
    })

    this._charmMaxUpdate = values
  }

  /**
   * Charm Max updating per variant
   */
  get typeCharmMax () {
    return this._typeCharmMax
  }

  set typeCharmMax (value) {
    this._typeCharmMax = value
  }

  /**
   * Summary open
   */
  get designSlideOut () {
    return this._designSlideOut
  }

  set designSlideOut (hidden) {
    this.els.design.element.ariaHidden = hidden
    this.initialiseDesignCarousel()

    this._designSlideOut = hidden
  }

  /**
   * Lead Times Drawer
   */
  get leadTimesDrawer () {
    return this._leadTimesDrawer
  }

  set leadTimesDrawer (hidden) {
    if (!this.els.leadTimes) return
    this.els.leadTimes.element.ariaHidden = hidden

    if (!hidden) {
      this.leadTimes = !hidden
    }

    this._leadTimesDrawer = hidden
  }

  getRandomInt (max, exclude) {
    let rand
    do {
      rand = Math.floor(Math.random() * max)
      // eslint-disable-next-line no-unmodified-loop-condition
    } while (rand === exclude && max > 1)
    return rand
  }

  /**
   * Randomise feeling lucky
   */
  get lucky () {
    return this._lucky
  }

  set lucky (lucky) {
    const json = JSON.parse(this.els.lucky.element.dataset.inspirationGroups)
    const randomIndex = this.getRandomInt(json.length, this.lucky)

    const products = json[randomIndex].products
      .split(',')
      .splice(0, this.visualiser.product.max)

    if (products.length === 0) {
      this._lucky = null
      return
    }

    this.updateCharm(products, 'lucky')

    this._lucky = randomIndex
  }
}

class BVSummary {
  static render (object) {
    // Product Image
    getElement('[data-summary="image"]').src = object.product.previewImage

    // Product type
    getElement('[data-summary="type"]').innerHTML = object.product.type

    // Product style
    getElement('[data-summary="style"]').innerHTML = object.product.style
    getElement('[data-summary-price="style"]').innerHTML = formatMoney(
      object.product.price,
    )

    // Product length
    getElement('[data-summary="length"]').innerHTML = object.product.length

    // Product material
    // getElement('[data-summary="material"]').innerHTML = object.product.material

    // Product charms
    let charmsHTML = ``
    object.charms.forEach((charm, index) => {
      const lines = []

      if (charm.engraving_text) {
        const engravingText = JSON.parse(charm.engraving_text)

        for (const pair of engravingText) {
          lines.push(pair[1])
        }
      }

      const engravingHTML = charm.engraving_text
        ? `<p class="vis-Summary_RowTextTitle fz-12_22">${theme.strings.bespoke.engraving} "${lines}"</p>`
        : ''

      charmsHTML += `<div class="vis-Summary_RowValue">
        <div class="vis-Summary_RowText">
          <p class="vis-Summary_RowTextTitle fz-14_171">${index + 1}. ${
        charm.name
      }</p>
          ${engravingHTML}
        </div>
        <p class="vis-Summary_RowPrice fz-14_171">${formatMoney(
          charm.price,
        )}</p>
        <p class="vis-Summary_RowEdit btn-Button btn-Button-underline fz-14_171" data-bespoke-visualiser-el="summary_edit" data-summary-edit="charms">${
          theme.strings.bespoke.edit
        }</p>
      </div>`
    })

    if (getElement('bespoke-visualiser').dataset.showSpacing === 'true') {
      charmsHTML += `<div class="vis-Summary_RowValue">
        <p class="vis-Summary_RowText fz-14_171">Spacing: ${object.product.spacing}cm</p>
        <p class="vis-Summary_RowPrice vis-Summary_RowPrice-na fz-14_171">${theme.strings.bespoke.na}</p>
        <p class="vis-Summary_RowEdit btn-Button btn-Button-underline fz-14_171" data-bespoke-visualiser-el="summary_edit" data-summary-edit="spacing">${theme.strings.bespoke.edit}</p>
      </div>`
    }

    getElement('[data-summary-group="charms"]').innerHTML = charmsHTML

    // Product design - variant title
    if (getElements('[data-summary="design"]')) {
      getElements('[data-summary="design"]').forEach(element => {
        element.innerHTML = object.product.base_variant_name
      })
    }

    if (getElements('[data-summary="delivery_text"]')) {
      getElements('[data-summary="delivery_text"]').forEach(element => {
        element.ariaHidden =
          object.product.base_variant_id !== element.dataset.id
      })
    }

    if (getElement('[data-summary-price="design"]')) {
      getElement('[data-summary-price="design"]').innerHTML = formatMoney(
        object.product.base_variant_price,
      )
    }

    // Summary total
    const totalCharmPrice = object.charms.reduce(
      (sum, charm) => sum + charm.price,
      0,
    )
    const productPrice = Number(object.product.price) || 0
    const shippingPrice = Number(object.product.base_variant_price) || 0

    getElements('[data-summary-total]').forEach(total => {
      total.innerHTML = formatMoney(
        productPrice + totalCharmPrice + shippingPrice,
      )
    })
  }

  static async addToCart (object, BV) {
    const items = []
    const bespokeId = new Date().getTime()

    // Upload image
    const url = `${window.theme.appUrl}/api/images?shop=${window.theme.permanentDomain}`

    const blob = await fetch(object.product.previewImage).then(res =>
      res.blob(),
    )

    const apiRequest = await fetch(url, {
      method: 'POST',
      body: blob,
    })

    const apiResponse = await apiRequest.json()

    items.push({
      id: object.product.base_variant_id,
      product_id: object.product.base_product_id,
      quantity: 1,
      properties: {
        _bespoke: bespokeId,
        _baseProduct: true,
        _previewImage: apiResponse.url,
        spacing: object.product.spacing,
      },
    })

    object.charms.forEach((charm, index) => {
      const charmProps = {
        _bespoke: bespokeId,
        _position: index + 1,
      }

      if (charm.engraving_text) {
        const engravingObj = JSON.parse(charm.engraving_text)
        charmProps._engraving_font = charm.engraving_font

        engravingObj.forEach(element => {
          charmProps[`Engraving_${element[0]}`] = element[1]
        })
      }

      items.push({
        id: charm.variant_id,
        product_id: charm.id,
        quantity: 1,
        properties: charmProps,
      })
    })

    items.push({
      id: object.product.variant_id,
      product_id: object.product.id,
      quantity: 1,
      properties: {
        _bespoke: bespokeId,
      },
    })

    window.BAO.Cart.addItem(items)
  }
}

class BVCanvas {
  constructor () {
    this._zoomSlider = document.querySelector('#vis-Zoom_Slider')

    document.querySelectorAll('.vis-Zoom_Icon').forEach(element => {
      element.addEventListener('click', e => {
        e.preventDefault()
        this.onZoomClick(element)
      })
    })

    this._zoomSlider.addEventListener('input', () => {
      this.onZoomSliderChange()
    })
  }

  async render (canvas, visualiser) {
    this._renderToken = (this._renderToken || 0) + 1
    const token = this._renderToken

    this.visualiser = visualiser
    this.charmScale = visualiser.product.charmScale / 1000
    this.charmPosition = visualiser.product.charmPosition / 100

    canvas.classList.add('vis-Visualiser_Canvas-loading')

    // Wait for CSS animation to finish
    await new Promise((resolve, reject) => setTimeout(resolve, 200))

    if (token !== this._renderToken) return null

    if (this.stage) this.stage.destroy()

    const minDimension = Math.min(canvas.offsetWidth, canvas.offsetHeight)

    this.stage = new Konva.Stage({
      container: 'vis-Visualiser_Canvas',
      width: minDimension,
      height: minDimension,
      draggable: true,
    })

    if (!visualiser.product.image) {
      canvas.classList.remove('vis-Visualiser_Canvas-loading')
      return null
    }

    await this.generateProductImage(visualiser)

    await this.generateCharmImages(visualiser)

    if (this.visualiser.charms.length) {
      if (this.zoomFactor === undefined) {
        this.zoomFactor = 2
      }
      this._zoomSlider.value = this.zoomFactor
    }

    this.stage.setAttrs(this.zoomOptions)

    canvas.classList.remove('vis-Visualiser_Canvas-loading')

    return this.generatePreview()
  }

  generatePreview () {
    this.generatingImage = true
    this.stage.setAttrs(this.zoomOptions)

    const preview = this.stage.toDataURL({ mimeType: 'image/jpeg' })

    this.generatingImage = false
    this.stage.setAttrs(this.zoomOptions)

    this.stage.to(this.zoomOptions)

    return preview
  }

  async generateProductImage () {
    const productLayer = new Konva.Layer()

    const productImg = await this.createImage(this.visualiser.product.image)

    const productImage = new Konva.Image({
      image: productImg,
      x: 0,
      y: 0,
      width: this.stageWidth,
      height: this.stageWidth,
      draggable: false,
    })

    productLayer.add(productImage)
    this.stage.add(productLayer)
  }

  async generateCharmImages () {
    const charmLayer = new Konva.Layer()

    const charmCount = this.visualiser.charms.length
    const points = this.generatePoints()
    const start = 180
    const spacing = this.visualiser.product.spacing * 8
    let offset = Math.round(start + (spacing * (charmCount - 1)) / 2)

    await Promise.all(
      this.visualiser.charms.map((charm, index) => {
        const point = points[offset]
        const rotation = offset + start

        offset = Math.round(offset - spacing)

        return this.generateCharmImage(
          charmLayer,
          charm,
          index,
          point,
          rotation,
        )
      }),
    )

    this.stage.add(charmLayer)

    this.bindDragDrop(charmLayer)
  }

  async generateCharmImage (charmLayer, charm, index, point, rotation) {
    const charmImg = await this.createImage(charm.image)
    const size = this.stageWidth * this.charmScale

    const hitboxScale = 10
    const charmImage = new Konva.Image({
      x: hitboxScale / 2,
      y: 0,
      image: charmImg,
      width: size,
      height: size,
    })

    const hitBox = new Konva.Rect({
      width: size + hitboxScale,
      height: size + hitboxScale,
    })

    const charmGroup = new Konva.Group({
      draggable: true,
      x: point.x,
      y: point.y,
      rotation,
      offsetX: (size + hitboxScale) / 2,
      charmIndex: index,
    })

    charmGroup.add(hitBox)
    charmGroup.add(charmImage)

    charmGroup.on('mouseenter', this.onCharmHover)
    charmGroup.on('mouseleave', this.onCharmBlur)
    charmGroup.on('click tap', () => this.onCharmClick(charmGroup))

    charmLayer.add(charmGroup)
  }

  bindDragDrop (charmLayer) {
    const tempLayer = new Konva.Layer()
    this.stage.add(tempLayer)

    let currentCharm
    let targetCharm
    let initialX, initialY, initialRotation

    this.stage.on('dragstart', e => {
      if (e.target.attrs.container) {
        return
      }
      currentCharm = e.target
      initialX = currentCharm.attrs.x
      initialY = currentCharm.attrs.y
      initialRotation = currentCharm.attrs.rotation

      currentCharm.moveTo(tempLayer)

      charmLayer.draw()
    })

    this.stage.on('dragmove', e => {
      if (e.target.attrs.container) {
        return
      }
      const pos = this.stage.getPointerPosition()
      const newTargetCharm = charmLayer.getIntersection(pos)?.parent
      if (targetCharm && !newTargetCharm) {
        targetCharm.to({
          scaleX: 1,
          scaleY: 1,
          duration: 0.15,
        })
      }
      if (newTargetCharm && newTargetCharm !== targetCharm) {
        newTargetCharm.to({
          scaleX: 1.15,
          scaleY: 1.15,
          duration: 0.15,
        })
      }
      targetCharm = newTargetCharm
    })

    this.stage.on('dragend', e => {
      if (e.target.attrs.container) {
        return
      }
      if (targetCharm) {
        currentCharm.to({
          x: targetCharm.attrs.x,
          y: targetCharm.attrs.y,
          rotation: targetCharm.attrs.rotation,
          scaleX: 1,
          scaleY: 1,
          duration: 0.35,
        })

        targetCharm.to({
          x: initialX,
          y: initialY,
          rotation: initialRotation,
          scaleX: 1,
          scaleY: 1,
          duration: 0.35,
          onFinish: () => {
            const previewImage = this.generatePreview()
            document.dispatchEvent(
              new CustomEvent('visualiser:updatePreview', {
                detail: { previewImage },
              }),
            )
          },
        })

        this.swapCharms(currentCharm, targetCharm)
      } else {
        currentCharm.to({
          x: initialX,
          y: initialY,
          scaleX: 1,
          scaleY: 1,
          duration: 0.35,
        })
      }

      currentCharm.moveTo(charmLayer)
      currentCharm = null
      targetCharm = null
    })
  }

  generatePoints () {
    if (
      this._pointsCache &&
      this._pointsCacheWidth === this.stageWidth &&
      this._pointsCachePosition === this.charmPosition
    ) {
      return this._pointsCache
    }

    const centerX = this.stageWidth * 0.5
    const centerY = this.stageWidth * 0.5
    const radius = this.stageWidth * this.charmPosition

    const points = []
    for (let degree = -90; degree < 270; degree++) {
      const radians = (degree * Math.PI) / 180
      points.push({
        x: centerX + radius * Math.cos(radians),
        y: centerY + radius * Math.sin(radians),
      })
    }

    this._pointsCache = points
    this._pointsCacheWidth = this.stageWidth
    this._pointsCachePosition = this.charmPosition
    return points
  }

  createImage (url) {
    return new Promise((resolve, reject) => {
      const image = new Image()
      image.crossOrigin = ''
      image.addEventListener('load', () => resolve(image))
      image.addEventListener('error', error => reject(error))
      image.src = url
    })
  }

  onCharmHover () {
    this.to({
      scaleX: 1.15,
      scaleY: 1.15,
      duration: 0.15,
    })
    document.body.style.cursor = 'pointer'
  }

  onCharmBlur () {
    this.to({
      scaleX: 1,
      scaleY: 1,
      duration: 0.15,
    })
    document.body.style.cursor = 'default'
  }

  onCharmClick (charmGroup) {
    document.dispatchEvent(
      new CustomEvent('visualiser:remove', {
        detail: { index: charmGroup.attrs.charmIndex },
      }),
    )
  }

  onZoomClick (element) {
    if (element.classList.contains('vis-Zoom_Icon-zoomIn')) {
      this.zoomFactor = this.zoomFactor + 1

      if (this.zoomFactor > 6) {
        this.zoomFactor = 6
      }
    } else {
      this.zoomFactor = this.zoomFactor - 1

      if (this.zoomFactor < 1) {
        this.zoomFactor = 2
      }
    }

    this._zoomSlider.value = this.zoomFactor
    this.stage.to(this.zoomOptions)
  }

  onZoomSliderChange () {
    this.zoomFactor = this._zoomSlider.value
    this.stage.to(this.zoomOptions)
  }

  swapCharms = (charm1, charm2) => {
    const charm1Index = charm1.attrs.charmIndex
    const charm2Index = charm2.attrs.charmIndex

    const temp = this.visualiser.charms[charm1Index]
    this.visualiser.charms[charm1Index] = this.visualiser.charms[charm2Index]
    this.visualiser.charms[charm2Index] = temp

    charm1.attrs.charmIndex = charm2Index
    charm2.attrs.charmIndex = charm1Index

    document.dispatchEvent(
      new CustomEvent('visualiser:reorder', {
        detail: { charms: this.visualiser.charms },
      }),
    )
  }

  get stage () {
    return this._stage
  }

  set stage (stage) {
    this._stage = stage
  }

  get stageWidth () {
    return this.stage.width()
  }

  get generatingImage () {
    return this._generatingImage
  }

  set generatingImage (generating) {
    this._generatingImage = generating
  }

  get zoomOptions () {
    const spacing = this.visualiser.product.spacing
    const charmCount = this.visualiser.charms.length

    let scale = 1
    let x = 0
    let y = 0

    scale = this.zoomFactor - (charmCount * spacing) / 10

    if (scale > 1 && charmCount !== 0 && this.generatingImage === false) {
      x = -(this.stageWidth * ((scale - 1) / 2))
      const yscale = scale - this.charmPosition
      const scaledWidth = this.stageWidth * yscale
      y =
        -(scaledWidth - (scaledWidth * this.charmPosition) / 4) +
        this.stageWidth / 5
    } else {
      scale = 1
    }

    return {
      scaleX: scale,
      scaleY: scale,
      x,
      y,
    }
  }

  get zoomFactor () {
    return this._zoomFactor
  }

  set zoomFactor (zoom) {
    this._zoomFactor = zoom
  }
}

if (!customElements.get('bespoke-visualiser')) {
  customElements.define('bespoke-visualiser', bespokeVisualiser)
}
